module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    style: ('min-height: ' + _vm.alturaContentWrapper + 'px')
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Edição de Formulário'
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm._.isNull(_vm.formularioCarregado.id) ? 'Novo Formulário' : (_vm.ehVisualizacao ? 'Visualiza' : 'Edição de') + ' formulário  ID ' + _vm.formularioCarregado.id))]), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao) ? _c('span', [(_vm._.isNull(_vm.formularioCarregado.id)) ? _c('span', [(_vm.salvaFormulario.statusSalvamento !== 'PROCESSANDO') ? _c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    attrs: {
      "color": "primary",
      "type": "button",
      "title": '<h5>Ao clicar ele criará este formulário no sistema para uso. Então antes de fazê-lo verifique se não existe um formulário desejado já criado</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cria novo formulário")]) : _vm._e(), _vm._v(" "), (_vm.salvaFormulario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Criando o formulário")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.formularioCarregado.id)) ? _c('span', [(_vm.salvaFormulario.statusSalvamento === 'PROCESSANDO') ? _c('span', {
    staticClass: "button--moema warning",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 50px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-borda-dark) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Salvando")]) : (_vm.salvaFormulario.statusSalvamento === 'FEITO') ? _c('span', {
    staticClass: "button--moema success",
    staticStyle: {
      "font-size": "12px",
      "padding": "8px 10px 10px 15px",
      "border-radius": "2px !important",
      "background": "var(--cor-verde) !important",
      "cursor": "not-allowed"
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Formulário salvo")]) : _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.salvarEdicao()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar alterações")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'cadastro-formulario'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), (!_vm._.isNull(_vm.formularioCarregado.id)) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.abreFormulario(_vm._.split(_vm.formularioCarregado.link_acesso, '-')[3])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Visualizar form em branco")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        _vm.abreFormulario(_vm._.split(_vm.formularioCarregado.link_acesso, '-')[2])
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link-square",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Visualização")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": [{
        text: 'Inicial',
        href: '/'
      }, {
        text: 'Cadastro',
        href: '#'
      }, {
        text: _vm._.isNull(_vm.formularioCarregado.id) ? 'Novo' : (_vm.ehVisualizacao ? 'Visualização' : 'Edição'),
        active: true
      }]
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTitulo),
      expression: "mostrarTitulo"
    }],
    staticClass: "box-body form-horizontal"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Título do Formulário")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.nome),
      expression: "formularioCarregado.nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "nome",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "nome",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>O nome do formulário aparecerá como título ao preencher.<br/>O SGP não permitirá duplicidade de nomes.</h5>'
    },
    domProps: {
      "value": (_vm.formularioCarregado.nome)
    },
    on: {
      "blur": _vm.verificaNomeJaExiste,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.fecharEdicao($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formularioCarregado, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Nome do formulário é obrigatório e não deve ser repetir")]) : _vm._e(), _vm._v(" "), (_vm.errors.first('nome_existe')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome_existe')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('tipo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.tipo),
      expression: "formularioCarregado.tipo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "tipo",
    staticClass: "form-control",
    attrs: {
      "name": "tipo",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>O tipo do formulário define seu fluxo e tratamento pelo sistema: <span style=\'text-align: left\'>' +
        '<p><span class=\'realce\'>Marco 0</span> ou <span class=\'realce\'>Marco 1</span> são enviados menualmente pela FBB ou automaticamente pelo SGP, aparecem para Validação (Análise) e podem ser devolvidos para Revisão</p>' +
        '<p><span class=\'realce\'>Genérico</span> é enviado só manualmente, não possui Validação (é encerrado ao Concluir) e pode ser usado como sub formulário</p>' +
        '<p><span class=\'realce\'>Participante</span> é iguai ao Genérico, mas é usado no cálculo de amostragem quando está como um sub formulário em outro do tipo Marco 0 ou 1</p>' +
        '</span></h5>'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.formularioCarregado.opcoes.periodicidade = null;
        _vm.formularioCarregado.opcoes.bi = !_vm._.includes(['AVALIACAO_GENERICO', 'AVALIACAO_PARTICIPANTE'], _vm.formularioCarregado.tipo)
      }]
    }
  }, _vm._l((_vm.tipoFormulario), function(tipo) {
    return _c('option', {
      domProps: {
        "value": tipo.codigo
      }
    }, [_vm._v(_vm._s(tipo.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('tipo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo')))]) : _vm._e(), _vm._v(" "), (_vm.errors.first('tipo_programa_existe')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo_programa_existe')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTitulo),
      expression: "mostrarTitulo"
    }],
    staticClass: "box-body form-horizontal"
  }, [(_vm.loading.programas) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando programas ...")]) : _vm._e(), _vm._v(" "), (!_vm.loading.programas) ? _c('span', [_c('div', {
    class: (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ? 'required-field' : '') + (_vm.errors.first('programas_sociais') ? ' has-error' : '')
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Programas")]), _vm._v(" "), _c('div', {
    class: _vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ? 'col-md-6' : 'col-md-10'
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ? 'required' : false),
      expression: "_.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], formularioCarregado.tipo) ? 'required' : false"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "programas_sociais",
    attrs: {
      "options": _vm.programasSociais,
      "multiple": true,
      "close-on-select": true,
      "placeholder": 'Pode vincular opcionalmente programas a este formulário',
      "track-by": "id",
      "custom-label": function (option) {
        return ("" + (option.id + ' - ' + option.descricao))
      },
      "label": "descricao",
      "selectedLabel": "Selecionado",
      "selectLabel": "Clique ou ENTER para selecionar",
      "deselectLabel": "Clique ou ENTER para remover",
      "name": "programas_sociais",
      "data-vv-as": "programas_sociais",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>' + (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo) ?
          'É obrigatório quando o tipo for Marco 0 ou 1<br/> Deve escolher somente um programa neste caso' :
          'É opcional quando o tipo for Genérico ou Particiapnte. Pode deixar em branco ou escolher um ou mais programas') +
        '<p>O(s) programa(s) escolhido(s) limitam quais projetos do SGP podem ser vinculados ao formulário que será preenchido</p>' +
        '</h5>'
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('span', {
          staticClass: "text-gray"
        }, [_vm._v(_vm._s(props.option.id) + " ")]), _vm._v(" " + _vm._s(props.option.descricao) + "\n                      ")]
      }
    }], null, false, 1030773195),
    model: {
      value: (_vm.formularioCarregado.opcoes.vinculo.programas),
      callback: function($$v) {
        _vm.$set(_vm.formularioCarregado.opcoes.vinculo, "programas", $$v)
      },
      expression: "formularioCarregado.opcoes.vinculo.programas"
    }
  }), _vm._v(" "), (_vm.errors.first('programas_sociais')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('programas_sociais')))]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['AVALIACAO_APROVACAO', 'AVALIACAO_ENCERRAMENTO'], _vm.formularioCarregado.tipo)) ? _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Prazo resposta")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.periodicidade),
      expression: "formularioCarregado.opcoes.periodicidade"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "periodicidade",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Definir prazo para cobrança de preenchimento da entidade</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes, "periodicidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Sem aviso")]), _vm._v(" "), _vm._l((12), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n) + " " + _vm._s(n > 1 ? 'meses' : 'mês'))])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTitulo),
      expression: "mostrarTitulo"
    }],
    staticClass: "box-body form-horizontal"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': (_vm.errors.first('apos abrir'))
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Após abrir")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.abrir.acao),
      expression: "formularioCarregado.opcoes.abrir.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "apos abrir",
    staticClass: "form-control",
    attrs: {
      "name": "apos abrir",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Logo que um formulário abrir para preenchimento ele pode estar:<span style=\'text-align: left\'>' +
        '<p><span class=\'realce\'>Normal</span> onde todos os campos e funcionalidades estarão disponíveis</p>' +
        '<p><span class=\'realce\'>Somente Leitura</span> força para que todo o conteúdo não possa ser alterado. Ideal para formulários (telas) de <b>agradecimento</b></p>' +
        '</span></h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes.abrir, "acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.acoesAposAbrir), function(acao) {
    return _c('option', {
      domProps: {
        "value": acao.codigo
      }
    }, [_vm._v(_vm._s(acao.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('apos abrir')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('apos abrir')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('elemento chave')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Elemento chave")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.elemento_chave),
      expression: "formularioCarregado.opcoes.elemento_chave"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "elemento chave",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Nesta lista aparecerão todos os elementos do tipo <i>TEXTO_SIMPLES</i> ou <i>NUMERO</i> que constam no formulário<br/><br/>' +
        '<p>Se um elemento desta lista for escolhido como chave, o sistema não permitirá durante o preenchimento que o formulário seja concluído se já houver outro entregue antes com o mesmo valor informado</p>' +
        '<p>Ideal para campos como CPF em formulários tipo Participante, por exemplo</p>' +
        '</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes, "elemento_chave", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Não há")]), _vm._v(" "), _vm._l((_vm._.filter(_vm.editandoFormulario, function(c) {
    return _vm._.includes(['NUMERO', 'TEXTO_SIMPLES'], c.elemento)
  })), function(controle, idx) {
    return _c('option', {
      domProps: {
        "value": controle.id
      }
    }, [_vm._v("(" + _vm._s(controle.id) + ") " + _vm._s(_vm.removerTagHtmlString(controle.titulo)))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTitulo),
      expression: "mostrarTitulo"
    }],
    staticClass: "box-body form-horizontal"
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': (_vm.errors.first('apos concluir') || _vm.errors.first('concluir_url') || _vm.errors.first('concluir_formulario'))
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Após Concluir")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.concluir.acao),
      expression: "formularioCarregado.opcoes.concluir.acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "apos concluir",
    staticClass: "form-control",
    attrs: {
      "name": "apos concluir",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Logo que o preenchimento de um formulário for concluído, o SGP:<span style=\'text-align: left\'>' +
        '<p><span class=\'realce\'>Sai da tela</span> de preenchimento e vai para a tela inicial ou SGP (comportamento padrão)</p>' +
        '<p><span class=\'realce\'>Abre o formulário</span> já criado para que inicie outro preenchimento (útil para <b>agradecimentos</b> ou encadeamento de formulários diferentes)</p>' +
        '<p><span class=\'realce\'>Vai para o endereço</span> defindo, por exemplo a página oficial da FBB ou outra url (útil para agregar valor ao formulário com outro site)</p>' +
        '</span></h5>'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes.concluir, "acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.formularioCarregado.opcoes.concluir.parametro = null
      }]
    }
  }, _vm._l((_vm.acoesAposConcluir), function(acao) {
    return _c('option', {
      domProps: {
        "value": acao.codigo
      }
    }, [_vm._v(_vm._s(acao.descricao))])
  }), 0), _vm._v(" "), (_vm.errors.first('apos concluir')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Escolha um item da lista")]) : _vm._e()]), _vm._v(" "), (_vm.formularioCarregado.opcoes.concluir.acao === 'ABRIR_URL') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.concluir.parametro),
      expression: "formularioCarregado.opcoes.concluir.parametro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "concluir_url",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "concluir_url",
      "disabled": _vm.ehVisualizacao,
      "placeholder": "https://www.fbb.org.br",
      "title": '<h5>Informe um url válida, exemplo <i>https://www.fbb.org.br</i><br/> que o SGP irá, logo após o preenchimento seja concluído pelo usuário<br/><br/>' +
        'Útil para complementar informação direcionando para páginas de parceiros ou notícias ou agradecimentos ou outro formulário (do SGP ou não) etc</h5>'
    },
    domProps: {
      "value": (_vm.formularioCarregado.opcoes.concluir.parametro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formularioCarregado.opcoes.concluir, "parametro", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('concluir_url')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Informe um endereço web para o qual o usuário que estiver preenchedo será direcionado após concluir")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.formularioCarregado.opcoes.concluir.acao === 'ABRIR_FORMULARIO') ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.concluir.parametro),
      expression: "formularioCarregado.opcoes.concluir.parametro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "concluir_formulario",
    staticClass: "form-control",
    attrs: {
      "name": "concluir_formulario",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Escolha nesta lista, um dos formulário ativos já cadastrados no SGP<br/><br/>' +
        '<p>Logo após o preenchimento seja concluído pelo usuário, o SGP abrirá o formulário selecionado</p>' +
        '<p>Atente que: o formulário novo aberto não faz parte do fluxo do formulário anterior</p>' +
        '<p>Assim, o novo não terá informações sensíveis ao processo anterior, que é útil para telas de agradecimento ou quando se quer separar informações e fluxos bem distintos (como um formulário sendo de proposta e outro de cadastro de entidade, por exemplo)</p>' +
        '</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes.concluir, "parametro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm._.filter(_vm.controles, ['grupo', 'FORMULARIO'])), function(formulario) {
    return _c('option', {
      domProps: {
        "value": formulario.configuracao.padrao[0]
      }
    }, [_vm._v(_vm._s(formulario.informacao))])
  }), 0), _vm._v(" "), (_vm.errors.first('concluir_formulario')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve informar um formulário que abrirá logo após concluir preenchimento deste formulário")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrarTitulo),
      expression: "mostrarTitulo"
    }],
    staticClass: "box-body form-horizontal"
  }, [_c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Numeração automática")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.numeracao),
      expression: "formularioCarregado.opcoes.numeracao"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "numeracao automatica",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Selecione a opção desejada quanto numeração das questões do form.</p>' +
        '<p>Atente que a numeração é atribuída a todos os elementos (exceto de layout), independentemente do elemento estar visível ou ocultado, ou seja,<br/>' +
        'se um formulário tiver elementos ocultos, a numeração vai aparentar que está \'quebrada\' ou não sequencial</p></h5>'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes, "numeracao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.numeracaoAutomatica]
    }
  }, _vm._l((_vm.opcoesNumeracaoAutomatica), function(acao) {
    return _c('option', {
      domProps: {
        "value": acao.codigo
      }
    }, [_vm._v(_vm._s(acao.descricao))])
  }), 0)])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Permitir observações")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.observacao),
      expression: "formularioCarregado.opcoes.observacao"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>Se desejar que haja um campo de observação opcional para o usuário fazer apontamentos, mas que não devem constar nos dados do formulário (não irão para O BI nem para o Excel), então escolha uma das opções abaixo de quem pode usar este campo</p>' +
        '<p>Atente para o que for informado neste campo ficará em destaque no topo do formulário preenchido e no histórico do fluxo do processo</p></h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes, "observacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoesObservacao), function(acao) {
    return _c('option', {
      domProps: {
        "value": acao.codigo
      }
    }, [_vm._v(_vm._s(acao.descricao))])
  }), 0)])]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Exibir histórico")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formularioCarregado.opcoes.historico),
      expression: "formularioCarregado.opcoes.historico"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "historico",
      "disabled": _vm.ehVisualizacao,
      "title": '<h5>O fluxo do processo gera um histórico de etapas concluídas (solicitação, revisão, análise etc) que podem ser vistos <b>por todos</b>, <b>só pela FBB</b> ou não exibidos</p>' +
        '<p>Observação: mesmo que o histórico não seja exibido, ele é gerado e guardado para conferência e auditoria, se necessário</p></h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formularioCarregado.opcoes, "historico", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.opcoesHistorico), function(acao) {
    return _c('option', {
      domProps: {
        "value": acao.codigo
      }
    }, [_vm._v(_vm._s(acao.descricao))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-9 alca_mostrar_ocultar",
    on: {
      "click": function($event) {
        _vm.mostrarTitulo = !_vm.mostrarTitulo
      }
    }
  }, [_c('div'), _c('i', {
    class: 'fa fa-chevron-' + (_vm.mostrarTitulo ? 'up' : 'down'),
    staticStyle: {
      "padding": "2px"
    }
  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 alca_mostrar_ocultar",
    on: {
      "click": function($event) {
        _vm.mostrarComponentes = !_vm.mostrarComponentes
      }
    }
  }, [_c('div'), _c('i', {
    class: 'fa fa-chevron-' + (_vm.mostrarComponentes ? 'right' : 'left'),
    staticStyle: {
      "padding": "2px 4px"
    }
  }), _vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.mostrarComponentes ? 'col-md-9' : 'col-md-12',
    style: ('overflow-y: auto; height: ' + (_vm.alturaContentWrapper - (_vm.mostrarTitulo ? 372 : 94)) + 'px;'),
    attrs: {
      "id": "edicao_formulario"
    }
  }, [(_vm.editandoFormulario.length === 0) ? _c('span', [_c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "div",
      "handle": ".handle",
      "group": "edicao",
      "list": _vm.editandoFormulario
    },
    on: {
      "start": function($event) {
        _vm.dragging = true
      },
      "end": function($event) {
        _vm.dragging = false
      }
    }
  }, 'draggable', {
    animation: 200,
    group: 'edicao',
    disabled: false,
    ghostClass: 'ghost'
  }, false), [_c('p', {
    staticStyle: {
      "margin": "20px",
      "font-style": "italic",
      "color": "var(--cor-destaque)"
    }
  }, [(_vm.errors.first('edicao_formulario')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('edicao_formulario')))]) : _c('span', [_vm._v("Conteúdo do formulário aqui"), _c('br'), _vm._v("Arraste para cá ou Clique num dos controles à direta")])])])], 1) : _c('span', [_c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "div",
      "handle": ".handle",
      "group": "edicao",
      "list": _vm.editandoFormulario
    },
    on: {
      "start": function($event) {
        _vm.dragging = true
      },
      "end": function($event) {
        _vm.dragging = false
      }
    }
  }, 'draggable', {
    animation: 200,
    group: 'edicao',
    disabled: false,
    ghostClass: 'ghost'
  }, false), _vm._l((_vm.editandoFormulario), function(controle, idx) {
    return _c('div', {
      class: 'box-body elemento' + (!controle.mostrar ? ' marcar_oculto' : '') +
        (!_vm._.isNull(_vm.editandoElemento) ? (_vm.editandoElemento.id !== controle.id ? ' controle_esmaecido' : ' caixa_propriedades') : '')
    }, [_c('div', {
      staticClass: "botoes_acao_elemento"
    }, [_c('span', {
      staticStyle: {
        "color": "var(--cor-fraca)",
        "padding": "0 5px",
        "cursor": "default"
      }
    }, [_vm._v(_vm._s(controle.id))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id),
        expression: "!_.isNull(editandoElemento) && editandoElemento.id === controle.id"
      }],
      staticClass: "botao_acao_elemento elemento_fechar",
      on: {
        "click": _vm.fecharEdicao
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (idx > 0),
        expression: "idx > 0"
      }],
      staticClass: "botao_acao_elemento elemento_mover",
      on: {
        "click": function($event) {
          return _vm.moveElemento(idx, -1, _vm.editandoFormulario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (idx < _vm.editandoFormulario.length - 1),
        expression: "idx < editandoFormulario.length - 1"
      }],
      staticClass: "botao_acao_elemento elemento_mover",
      on: {
        "click": function($event) {
          return _vm.moveElemento(idx, 1, _vm.editandoFormulario)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm._.find(_vm.editandoFormulario, ['id', controle.bi])),
        expression: "!_.find(editandoFormulario, ['id', controle.bi])"
      }],
      staticClass: "botao_acao_elemento elemento_duplicar",
      on: {
        "click": function($event) {
          return _vm.duplicaElemento(idx, controle)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-files-o"
    })]), _vm._v(" "), _c('span', {
      staticClass: "botao_acao_elemento elemento_excluir",
      on: {
        "click": function($event) {
          return _vm.removeElemento(idx)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), (_vm._.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging)),
        expression: "!(!_.isNull(editandoElemento) && editandoElemento.id === controle.id && !dragging)"
      }],
      on: {
        "click": function($event) {
          return _vm.editaElemento(idx)
        }
      }
    }, [_c('div', {
      ref: controle.id,
      refInFor: true,
      class: 'row handle' + (controle.obrigatorio ? ' required-field' : ''),
      attrs: {
        "id": controle.id
      }
    }, [_c('label', {
      staticClass: "control-label col-md-12 tituloControle"
    }, [(!_vm._.isNull(_vm.formularioCarregado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
      staticClass: "text-gray"
    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Informe o tílulo' : controle.titulo)
      }
    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle",
      attrs: {
        "title": '<h5>' + (controle.descricao) + '</h5>',
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), (controle.elemento === 'NUMERO') ? _c('div', {
      class: _vm._.includes(['TELEFONE', 'CNPJ', 'CPF'], controle.configuracao.formato) ? 'col-md-4' : 'col-md-3'
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": true,
        "placeholder": controle.configuracao.formato === 'CPF' ? '000.000.000-00' : (controle.configuracao.formato === 'CNPJ' ? '00.000.000/0000-00' :
          (controle.configuracao.formato === 'TELEFONE' ? '(00) 0000-0000' :
            (controle.configuracao.formato === 'INTEIRO' ? '0' :
              (controle.configuracao.formato === 'CEP' ? '00000-000' :
                (controle.configuracao.formato === 'DECIMAL' ? '0,0000' : 'R$ 0,00')))))
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_SIMPLES') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": true,
        "maxlength": _vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 250 : _vm._.toSafeInteger(controle.configuracao.maximo)
      }
    }), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1) ? _c('i', {
      staticStyle: {
        "float": "right",
        "color": "silver"
      }
    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'TEXTO_LONGO') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('textarea', {
      directives: [{
        name: "resizable",
        rawName: "v-resizable"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": true
      }
    }), _vm._v(" "), (_vm._.toSafeInteger(controle.configuracao.maximo) > 1 && controle.configuracao.formato === 'SOMENTE_TEXTO') ? _c('i', {
      staticStyle: {
        "float": "right",
        "color": "silver"
      }
    }, [_vm._v("Até " + _vm._s(_vm._.toSafeInteger(controle.configuracao.maximo)) + " caracteres")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_SIMPLES') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('select', {
      staticClass: "form-control",
      attrs: {
        "disabled": true
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SELECAO_MULTIPLA') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('select', {
      staticClass: "form-control",
      attrs: {
        "disabled": true
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'BOOLEANO') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('span', [_c('label', {
      staticClass: "radio-inline new-control new-control-radio",
      staticStyle: {
        "padding-top": "7px"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "disabled": true
      }
    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[0].descricao) + " "), _c('div', {
      staticClass: "new-control-indicator"
    })]), _vm._v(" "), _c('label', {
      staticClass: "radio-inline new-control new-control-radio",
      staticStyle: {
        "padding-top": "7px"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "disabled": true
      }
    }), _vm._v(" " + _vm._s(controle.configuracao.conteudo.linhas[1].descricao) + " "), _c('div', {
      staticClass: "new-control-indicator"
    })])])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'CLASSIFICACAO') ? _c('div', {
      staticClass: "col-md-12"
    }, [(controle.configuracao.formato === 'NUMEROS') ? _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
      return _c('span', {
        staticClass: "fa fa-stack fa-2x elemento_classificacao classificacao_numeral"
      }, [_c('i', {
        staticClass: "fa fa-solid fa-circle-thin fa-stack-1x"
      }), _vm._v(" "), _c('span', {
        staticClass: "fa fa-stack-1x"
      }, [_vm._v(_vm._s(n))])])
    }), 0) : _c('span', _vm._l((_vm._.range(_vm._.toSafeInteger(controle.configuracao.minimo), _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
      return _c('i', {
        class: 'elemento_classificacao fa fa-2x ' + (_vm._.isNull(controle.configuracao.formato) || controle.configuracao.formato === 'ESTRELA' ? 'fa-star-o' : (controle.configuracao.formato === 'CIRCULO' ? 'fa-circle-thin' : (controle.configuracao.formato === 'LIKE' ? 'fa-thumbs-o-up' : 'fa-smile-o')))
      })
    }), 0)]) : _vm._e(), _vm._v(" "), (controle.elemento === 'DATA') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "disabled": true
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'PERIODO') ? _c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-btn"
    }, [_c('span', {
      staticClass: "btn",
      staticStyle: {
        "cursor": "default"
      }
    }, [_vm._v("De")])]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "disabled": true
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-btn"
    }, [_c('span', {
      staticClass: "btn",
      staticStyle: {
        "cursor": "default"
      }
    }, [_vm._v("Até")])]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "date",
        "disabled": true
      }
    })])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'NPS') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('table', {
      staticClass: "elemento_NPS_escala",
      attrs: {
        "border": "1"
      }
    }, [_c('tr', _vm._l((_vm._.range(1, _vm._.toSafeInteger(controle.configuracao.padrao) + 1)), function(n) {
      return _c('td', {
        staticClass: "text-center"
      }, [_vm._v(" " + _vm._s(n) + " ")])
    }), 0)]), _vm._v(" "), _c('table', {
      staticClass: "elemento_NPS_limites"
    }, [_c('tr', [_c('td', {
      staticClass: "truncar"
    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[0].descricao))]), _c('td', {
      staticClass: "text-right truncar"
    }, [_vm._v(_vm._s(controle.configuracao.conteudo.linhas[1].descricao))])])])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LIKERT') ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('table', {
      staticClass: "elemento_likert_matrix table-hover"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "w30"
    }, [_vm._v(" ")]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna) {
      return (coluna.mostrar) ? _c('th', {
        staticClass: "elemento_likert_cabecalho_coluna"
      }, [_vm._v(_vm._s(coluna.descricao))]) : _vm._e()
    })], 2)]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.linhas), function(linha) {
      return _c('tr', [_c('td', {
        staticClass: "elemento_likert_pergunta"
      }, [_vm._v(_vm._s(_vm._.isEmpty(linha.descricao) ? 'Informe uma questão ...' : linha.descricao))]), _vm._v(" "), _vm._l((controle.configuracao.conteudo.colunas), function(coluna) {
        return (coluna.mostrar) ? _c('td', {
          staticClass: "elemento_likert_opcoes"
        }, [_c('i', {
          staticClass: "fa fa-circle-thin fa-2x"
        })]) : _vm._e()
      })], 2)
    })], 2)]) : _vm._e(), _vm._v(" "), (controle.elemento === 'UF_MUNICIPIO') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('multiselect', {
      attrs: {
        "placeholder": "Nome do município",
        "options": [],
        "disabled": true
      }
    })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['LAYOUT'], controle.grupo)) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging)),
        expression: "!(!_.isNull(editandoElemento) && editandoElemento.id === controle.id && !dragging)"
      }],
      on: {
        "click": function($event) {
          return _vm.editaElemento(idx)
        }
      }
    }, [(controle.elemento === 'TEXTO_FIXO') ? _c('div', {
      staticClass: "row handle"
    }, [_c('div', {
      staticClass: "col-md-12",
      domProps: {
        "innerHTML": _vm._s(controle.titulo)
      }
    })]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LINHA_HORIZONTAL') ? _c('div', {
      staticClass: "row handle"
    }, [_c('hr')]) : _vm._e(), _vm._v(" "), (controle.elemento === 'LOGOMARCA_FBB') ? _c('div', {
      staticClass: "row handle"
    }, [(!_vm._.isEmpty(controle.descricao)) ? _c('div', {
      staticClass: "col-md-12"
    }, [_c('a', {
      attrs: {
        "href": controle.descricao
      }
    }, [_c('img', {
      attrs: {
        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
        "alt": controle.titulo
      }
    })])]) : _c('div', {
      staticClass: "col-md-12"
    }, [_c('img', {
      attrs: {
        "src": _vm._.get(controle.configuracao, 'formato', 'LOGO_HORIZONTAL') === 'LOGO_HORIZONTAL' ? '/static/img/logo-login.png' : '/static/img/logo-vertical.png',
        "alt": controle.titulo
      }
    })])]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SECAO') ? _c('div', {
      class: ('secao_' + (_vm._.isEmpty(controle.configuracao) ? 'padrao' : _vm._.toLower(controle.configuracao.formato))) + ' row handle',
      style: (!_vm._.isNull(_vm.editandoFormulario) ? 'color: black !important' : '')
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(controle.titulo)
      }
    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle",
      attrs: {
        "title": '<h5>' + (controle.descricao) + '</h5>',
        "aria-hidden": "true"
      }
    }) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.grupo === 'FORMULARIO') ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!(!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging)),
        expression: "!(!_.isNull(editandoElemento) && editandoElemento.id === controle.id && !dragging)"
      }],
      on: {
        "click": function($event) {
          return _vm.editaElemento(idx)
        }
      }
    }, [_c('div', {
      staticClass: "row handle"
    }, [_c('label', {
      staticClass: "control-label col-md-12"
    }, [(!_vm._.isNull(_vm.formularioCarregado.opcoes.numeracao) && _vm._.has(controle, 'numeracao')) ? _c('span', {
      staticClass: "text-gray"
    }, [_vm._v(_vm._s(controle.numeracao) + ")")]) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm._.isEmpty(controle.titulo) ? 'Informe o tílulo' : controle.titulo)
      }
    }), _vm._v(" "), (_vm._.has(controle, 'descricao') && !_vm._.isEmpty(controle.descricao)) ? _c('i', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "fa fa-question-circle",
      attrs: {
        "title": '<h5>' + (controle.descricao) + '</h5>',
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), (!_vm._.includes(['SOMENTE_LINK'], controle.configuracao.formato)) ? _c('span', [(_vm._.includes(['COMPLETO_COM_LINK', 'COMPLETO_SEM_LINK'], controle.configuracao.formato)) ? _c('div', {
      staticClass: "col-md-2"
    }, [_c('g-button-ujarak', {
      attrs: {
        "color": "primary",
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("  Adicionar")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Pesquisa...",
        "disabled": true
      }
    })]), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COM_LINK')) ? _c('div', {
      staticClass: "col-md-6"
    }, [_vm._v("\n                                  Link para este formulário: "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm.urlLaravel + '/formulario/' + controle.configuracao.padrao[0]))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_vm._v(" ")]), _vm._v(" "), _c('div', {}, [_c('b-container', {
      attrs: {
        "fluid": ""
      }
    }, [_c('b-table', {
      attrs: {
        "show-empty": "",
        "stacked": "md",
        "striped": "",
        "bordered": controle.configuracao.conteudo.bordered,
        "items": controle.valor,
        "fields": controle.configuracao.conteudo.colunas,
        "current-page": controle.configuracao.conteudo.currentPage,
        "per-page": controle.configuracao.conteudo.perPage,
        "empty-filtered-text": "Nada foi encontrado. Refaça sua pesquisa!",
        "empty-text": "Nenhum registro encontrado",
        "sort-by": controle.configuracao.conteudo.sortBy,
        "sort-desc": controle.configuracao.conteudo.sortDesc
      },
      on: {
        "update:sortBy": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
        },
        "update:sort-by": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortBy", $event)
        },
        "update:sortDesc": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
        },
        "update:sort-desc": function($event) {
          return _vm.$set(controle.configuracao.conteudo, "sortDesc", $event)
        }
      },
      scopedSlots: _vm._u([(!_vm._.includes(controle.configuracao.formato, 'MINIMO')) ? {
        key: "actions",
        fn: function(row) {
          return [(_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
            attrs: {
              "color": "primary",
              "size": "button--size-ss"
            }
          }, [_c('i', {
            staticClass: "fa fa-pencil-square-o",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" Editar")]) : _vm._e(), _vm._v(" "), (_vm._.includes(controle.configuracao.formato, 'COMPLETO')) ? _c('g-button-ujarak', {
            attrs: {
              "color": "error",
              "size": "button--size-ss"
            }
          }, [_c('i', {
            staticClass: "fa fa-trash",
            attrs: {
              "aria-hidden": "true"
            }
          }), _vm._v(" Excluir")]) : _vm._e(), _vm._v(" "), _c('g-button-ujarak', {
            attrs: {
              "color": "success",
              "size": "button--size-ss"
            }
          }, [_c('i', {
            staticClass: "fa fa-search",
            attrs: {
              "aria-label": "false"
            }
          }), _vm._v(" Visualizar")])]
        }
      } : null], null, true)
    }), _vm._v(" "), _c('b-row', [_c('b-col', {
      staticClass: "my-1",
      attrs: {
        "md": "6",
        "right": ""
      }
    }, [_c('b-pagination', {
      staticClass: "my-3",
      attrs: {
        "total-rows": controle.configuracao.conteudo.totalRows,
        "per-page": controle.configuracao.conteudo.perPage
      },
      model: {
        value: (controle.configuracao.conteudo.currentPage),
        callback: function($$v) {
          _vm.$set(controle.configuracao.conteudo, "currentPage", $$v)
        },
        expression: "controle.configuracao.conteudo.currentPage"
      }
    })], 1)], 1)], 1)], 1)]) : _c('span', [_c('div', {
      staticClass: "col-md-12"
    }, [_vm._v("\n                                  Link de acesso para este formulário. Repasse para quem for preencher ele: "), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm.urlLaravel + '/formulario/' + controle.configuracao.padrao[0]))])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(_vm.editandoElemento) && _vm.editandoElemento.id === controle.id && !_vm.dragging) ? _c('div', {
      staticClass: "elemento_propriedades well-sm form-horizontal"
    }, [_c('div', {
      staticClass: "form-group required-field"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v(_vm._s(controle.elemento === 'TEXTO_FIXO' ? 'Texto' : 'Título'))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('quill-editor', {
      ref: "refQuillEditor",
      refInFor: true,
      attrs: {
        "disabled": controle.grupo === 'PERSONALIZADO',
        "options": controle.elemento === 'TEXTO_FIXO' ? _vm.quillOptionsCompleto : _vm.quillOptionsTitulo
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.fecharEdicao($event)
        }
      },
      model: {
        value: (controle.titulo),
        callback: function($$v) {
          _vm.$set(controle, "titulo", $$v)
        },
        expression: "controle.titulo"
      }
    })], 1)]), _vm._v(" "), (controle.elemento !== 'TEXTO_FIXO') ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Ajuda")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.descricao),
        expression: "controle.descricao"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (controle.descricao)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.fecharEdicao($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle, "descricao", $event.target.value)
        }
      }
    }), _vm._v(" "), (!_vm._.isEmpty(controle.descricao) || controle.grupo !== 'PERSONALIZADO') ? _c('span', {
      staticClass: "input-group-btn"
    }, [_c('button', {
      staticClass: "btn",
      staticStyle: {
        "background": "white",
        "border-color": "#d2d6de",
        "border-width": "1px 1px 1px 0px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          controle.descricao = null
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    })])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Opções")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10 indicadores-cb-inline"
    }, [(_vm._.includes(['CONTROLE', 'PERSONALIZADO'], controle.grupo)) ? _c('div', {
      staticClass: "juntos"
    }, [_c('i', {
      class: (controle.obrigatorio ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          controle.obrigatorio = !controle.obrigatorio
        }
      }
    }), _vm._v(" "), _c('span', {
      class: controle.obrigatorio ? 'selecionado' : ''
    }, [_vm._v(" Obrigatório")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "juntos"
    }, [(controle.elemento === 'SECAO') ? _c('span', [_c('i', {
      class: (controle.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.mostraOcultaElemento(idx)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: controle.mostrar ? 'selecionado' : ''
    }, [_vm._v(" " + _vm._s('Mostrará ou Ocultará ' + (_vm.elementosSecao(idx).length === 0 ? 'esta seção' : 'os elementos nesta seção')))])]) : _c('span', [(_vm._.isNull(_vm.elementosSecao(idx)) || _vm._.get(_vm.elementosSecao(idx), 'mostrar')) ? _c('span', [_c('i', {
      class: (controle.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.mostraOcultaElemento(idx)
        }
      }
    }), _vm._v(" "), _c('span', {
      class: controle.mostrar ? 'selecionado' : ''
    }, [_vm._v(" Mostrar")])]) : _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      attrs: {
        "title": '<h5>Este elemento está em uma seção oculta, então não pode ser mostrado isoladamente</h5>'
      }
    }, [_c('i', {
      staticClass: "fa fa-square"
    }), _vm._v(" Seção ocultada\n                                    ")])])])])]), _vm._v(" "), (!_vm._.isEmpty(controle.configuracao)) ? _c('span', [(_vm._.includes(['NUMERO', 'LOGOMARCA_FBB', 'CLASSIFICACAO', 'TEXTO_LONGO', 'SUB_FORMULARIO', 'SELECAO_SIMPLES', 'SECAO'], controle.elemento)) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Formato")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.configuracao.formato),
        expression: "controle.configuracao.formato"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": controle.grupo === 'PERSONALIZADO'
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(controle.configuracao, "formato", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm._.get(_vm._.find(_vm.formatoValores, ['elemento', controle.elemento]), 'formatos')), function(item) {
      return _c('option', {
        domProps: {
          "value": item.valor
        }
      }, [_vm._v(_vm._s(item.descricao) + " ")])
    }), 0)]), _vm._v(" "), (controle.grupo === 'FORMULARIO') ? _c('span', [_vm._v("\n                                  " + _vm._s(_vm._.get(_vm._.find(_vm._.get(_vm._.find(_vm.formatoValores, ['elemento', 'SUB_FORMULARIO']), 'formatos'), ['valor', controle.configuracao.formato]), 'info')) + "\n                                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['TEXTO_SIMPLES', 'CLASSIFICACAO', 'NPS'], controle.elemento) || (controle.elemento === 'NUMERO' && _vm._.includes(['INTEIRO', 'DECIMAL', 'MOEDA'], controle.configuracao.formato)) || (controle.elemento === 'TEXTO_LONGO' && _vm._.includes(['SOMENTE_TEXTO'], controle.configuracao.formato))) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Quantidade")]), _vm._v(" "), (_vm._.includes(['CLASSIFICACAO', 'NPS'], controle.elemento)) ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.configuracao.padrao),
        expression: "controle.configuracao.padrao"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": controle.configuracao.minimo,
        "max": controle.configuracao.maximo,
        "disabled": controle.grupo === 'PERSONALIZADO',
        "title": '<h5>Limite de <b>' + controle.configuracao.minimo + '</b> até <b>' + controle.configuracao.maximo + '</b></h5>'
      },
      domProps: {
        "value": (controle.configuracao.padrao)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.fecharEdicao($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle.configuracao, "padrao", $event.target.value)
        }
      }
    })]) : (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento)) ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.configuracao.maximo),
        expression: "controle.configuracao.maximo"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          arrow: true
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": controle.configuracao.minimo,
        "max": "2147483647",
        "disabled": controle.grupo === 'PERSONALIZADO',
        "title": '<h5>' + (_vm._.toSafeInteger(controle.configuracao.maximo) === 0 ? 'Sem limite de caracteres' : (_vm._.toSafeInteger(controle.configuracao.maximo) > 1 ? 'Limitado a ' + _vm._.toSafeInteger(controle.configuracao.maximo) + ' caracteres' : '1 caractere somente')) + '</h5>'
      },
      domProps: {
        "value": (controle.configuracao.maximo)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.fecharEdicao($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle.configuracao, "maximo", $event.target.value)
        }
      }
    })]) : ((controle.elemento === 'NUMERO' && _vm._.includes(['INTEIRO', 'DECIMAL', 'MOEDA'], controle.configuracao.formato))) ? _c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "col-md-1"
    }, [_vm._v("De")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.configuracao.minimo),
        expression: "controle.configuracao.minimo"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": "0",
        "max": controle.configuracao.maximo,
        "disabled": controle.grupo === 'PERSONALIZADO'
      },
      domProps: {
        "value": (controle.configuracao.minimo)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.fecharEdicao($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle.configuracao, "minimo", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_vm._v("Até")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (controle.configuracao.maximo),
        expression: "controle.configuracao.maximo"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "min": controle.configuracao.minimo,
        "max": "2147483647",
        "disabled": controle.grupo === 'PERSONALIZADO'
      },
      domProps: {
        "value": (controle.configuracao.maximo)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          return _vm.fecharEdicao($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(controle.configuracao, "maximo", $event.target.value)
        }
      }
    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO', 'NPS', 'LIKERT'], controle.elemento) && !_vm._.isNull(controle.configuracao.conteudo)) ? _c('div', [(!_vm._.isNull(controle.configuracao.conteudo.linhas)) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Conteúdo")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('table', {
      class: 'table table-condensed ' + (controle.grupo === 'PERSONALIZADO' ? '' : 'table-hover')
    }, [(controle.configuracao.formato === 'CONTEUDO_FIXO') ? _vm._l((controle.configuracao.conteudo.linhas), function(item, idx) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "40%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.descricao),
          expression: "item.descricao"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "disabled": controle.grupo === 'PERSONALIZADO'
        },
        domProps: {
          "value": (item.descricao)
        },
        on: {
          "keydown": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.fecharEdicao($event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "descricao", $event.target.value)
          }
        }
      })]), _vm._v(" "), (!_vm._.isNull(item.valor) && item.valor !== '') ? _c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.valor),
          expression: "item.valor"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "disabled": controle.grupo === 'PERSONALIZADO'
        },
        domProps: {
          "value": (item.valor)
        },
        on: {
          "keydown": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.fecharEdicao($event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "valor", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), _c('td')])
    }) : [_c('draggable', _vm._b({
      attrs: {
        "group": "lista_conteudo",
        "disabled": controle.grupo === 'PERSONALIZADO',
        "tag": "tbody"
      },
      model: {
        value: (controle.configuracao.conteudo.linhas),
        callback: function($$v) {
          _vm.$set(controle.configuracao.conteudo, "linhas", $$v)
        },
        expression: "controle.configuracao.conteudo.linhas"
      }
    }, 'draggable', {
      animation: 200,
      group: 'lista_conteudo',
      disabled: false,
      ghostClass: 'ghost'
    }, false), _vm._l((controle.configuracao.conteudo.linhas), function(item, idx) {
      return _c('tr', {
        class: controle.grupo !== 'PERSONALIZADO' ? 'item_conteudo handle_conteudo' : ''
      }, [_c('td', {
        staticClass: "w40",
        style: (!item.mostrar ? 'border-left: 5px solid slategray;' : '')
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.descricao),
          expression: "item.descricao"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "disabled": controle.grupo === 'PERSONALIZADO'
        },
        domProps: {
          "value": (item.descricao)
        },
        on: {
          "keydown": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.fecharEdicao($event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "descricao", $event.target.value)
          }
        }
      })]), _vm._v(" "), (!_vm._.isNull(item.valor) && item.valor !== '') ? _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.valor),
          expression: "item.valor"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "disabled": controle.grupo === 'PERSONALIZADO'
        },
        domProps: {
          "value": (item.valor)
        },
        on: {
          "keydown": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
            return _vm.fecharEdicao($event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(item, "valor", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (false) ? _c('td', {
        staticClass: "text-left indicadores-cb-inline w20",
        staticStyle: {
          "padding": "0 10px"
        }
      }, [_c('i', {
        class: (item.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            item.mostrar = !item.mostrar
          }
        }
      }), _vm._v(" "), _c('span', {
        class: controle.mostrar ? 'selecionado' : ''
      }, [_vm._v(" Mostrar")])]) : _vm._e(), _vm._v(" "), _c('td', {
        staticClass: "text-right w40"
      }, [(controle.grupo !== 'PERSONALIZADO') ? _c('div', {
        staticClass: "botoes_acao_conteudo"
      }, [_c('span', {
        staticClass: "botao_acao_conteudo elemento_duplicar",
        on: {
          "click": function($event) {
            controle.configuracao.conteudo.linhas.splice(idx, 0, {
              descricao: '' + (controle.configuracao.conteudo.linhas.length + 1),
              valor: null,
              mostrar: true
            })
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-plus"
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (idx > 0),
          expression: "idx > 0"
        }],
        staticClass: "botao_acao_elemento elemento_mover",
        on: {
          "click": function($event) {
            return _vm.moveElemento(idx, -1, controle.configuracao.conteudo.linhas)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-arrow-up"
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (idx < controle.configuracao.conteudo.linhas.length - 1),
          expression: "idx < controle.configuracao.conteudo.linhas.length - 1"
        }],
        staticClass: "botao_acao_elemento elemento_mover",
        on: {
          "click": function($event) {
            return _vm.moveElemento(idx, 1, controle.configuracao.conteudo.linhas)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-arrow-down"
      })]), _vm._v(" "), (controle.configuracao.conteudo.linhas.length > 1) ? _c('span', {
        staticClass: "botao_acao_conteudo elemento_excluir",
        on: {
          "click": function($event) {
            return controle.configuracao.conteudo.linhas.splice(idx, 1)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()]) : _c('div', [_vm._v(" ")])])])
    }), 0)]], 2)])]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(controle.configuracao.conteudo.colunas)) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Colunas")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('table', {
      class: 'table table-condensed ' + (controle.grupo === 'PERSONALIZADO' ? '' : 'table-hover')
    }, [
      [_c('draggable', _vm._b({
        attrs: {
          "group": "lista_conteudo",
          "disabled": controle.grupo === 'PERSONALIZADO',
          "tag": "tbody"
        },
        model: {
          value: (controle.configuracao.conteudo.colunas),
          callback: function($$v) {
            _vm.$set(controle.configuracao.conteudo, "colunas", $$v)
          },
          expression: "controle.configuracao.conteudo.colunas"
        }
      }, 'draggable', {
        animation: 200,
        group: 'lista_conteudo',
        disabled: false,
        ghostClass: 'ghost'
      }, false), _vm._l((controle.configuracao.conteudo.colunas), function(item, idx) {
        return _c('tr', {
          class: controle.grupo !== 'PERSONALIZADO' ? 'item_conteudo handle_conteudo' : ''
        }, [_c('td', {
          staticClass: "w40",
          style: (!item.mostrar ? 'border-left: 5px solid slategray;' : '')
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.descricao),
            expression: "item.descricao"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "disabled": controle.grupo === 'PERSONALIZADO'
          },
          domProps: {
            "value": (item.descricao)
          },
          on: {
            "keydown": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
              return _vm.fecharEdicao($event)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(item, "descricao", $event.target.value)
            }
          }
        })]), _vm._v(" "), (!_vm._.isNull(item.valor) && item.valor !== '') ? _c('td', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (item.valor),
            expression: "item.valor"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "disabled": controle.grupo === 'PERSONALIZADO'
          },
          domProps: {
            "value": (item.valor)
          },
          on: {
            "keydown": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
              return _vm.fecharEdicao($event)
            },
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(item, "valor", $event.target.value)
            }
          }
        })]) : _vm._e(), _vm._v(" "), (false) ? _c('td', {
          staticClass: "text-left indicadores-cb-inline w20",
          staticStyle: {
            "padding": "0 10px"
          }
        }, [_c('i', {
          class: (item.mostrar ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              item.mostrar = !item.mostrar
            }
          }
        }), _vm._v(" "), _c('span', {
          class: controle.mostrar ? 'selecionado' : ''
        }, [_vm._v(" Mostrar")])]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-right w40"
        }, [(controle.grupo !== 'PERSONALIZADO') ? _c('div', {
          staticClass: "botoes_acao_conteudo"
        }, [_c('span', {
          staticClass: "botao_acao_conteudo elemento_duplicar",
          on: {
            "click": function($event) {
              return controle.configuracao.conteudo.colunas.splice(idx, 0, {
                descricao: 'Item novo ...',
                valor: null,
                mostrar: true
              })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus"
        })]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (idx > 0),
            expression: "idx > 0"
          }],
          staticClass: "botao_acao_elemento elemento_mover",
          on: {
            "click": function($event) {
              return _vm.moveElemento(idx, -1, controle.configuracao.conteudo.colunas)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (idx < controle.configuracao.conteudo.colunas.length - 1),
            expression: "idx < controle.configuracao.conteudo.colunas.length - 1"
          }],
          staticClass: "botao_acao_elemento elemento_mover",
          on: {
            "click": function($event) {
              return _vm.moveElemento(idx, 1, controle.configuracao.conteudo.colunas)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-down"
        })]), _vm._v(" "), (controle.configuracao.conteudo.colunas.length > 1) ? _c('span', {
          staticClass: "botao_acao_conteudo elemento_excluir",
          on: {
            "click": function($event) {
              return controle.configuracao.conteudo.colunas.splice(idx, 1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash"
        })]) : _vm._e()]) : _c('div', [_vm._v(" ")])])])
      }), 0)]
    ], 2)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (controle.elemento === 'SUB_FORMULARIO') ? _c('div', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "control-label col-md-2"
    }, [_vm._v("Colunas")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-10"
    }, [_c('table', {
      staticClass: "table table-condensed table-hover"
    }, [_c('draggable', _vm._b({
      attrs: {
        "group": "lista_conteudo",
        "tag": "tbody"
      },
      model: {
        value: (controle.configuracao.conteudo.colunas),
        callback: function($$v) {
          _vm.$set(controle.configuracao.conteudo, "colunas", $$v)
        },
        expression: "controle.configuracao.conteudo.colunas"
      }
    }, 'draggable', {
      animation: 200,
      group: 'lista_conteudo',
      disabled: false,
      ghostClass: 'ghost'
    }, false), [(_vm._.isEmpty(_vm.editandoColunaSubFormulario)) ? [_vm._l((_vm._.filter(controle.configuracao.conteudo.colunas, function(c) {
      return c.key != 'actions'
    })), function(item, idx) {
      return _c('tr', {
        staticClass: "item_conteudo handle_conteudo"
      }, [_c('td', {
        staticClass: "w30 truncar"
      }, [_c('span', {
        staticStyle: {
          "color": "var(--cor-destaque)"
        }
      }, [_vm._v(_vm._s(item.key))]), _vm._v(" " + _vm._s(_vm.removerTagHtmlString(item.label)))]), _vm._v(" "), _c('td', {
        staticClass: "text-right w20"
      }, [(controle.configuracao.conteudo.colunas.length > 1) ? _c('div', {
        staticClass: "botoes_acao_conteudo"
      }, [_c('span', {
        staticClass: "botao_acao_elemento elemento_fechar",
        on: {
          "click": function($event) {
            _vm.editandoColunaSubFormulario = controle.configuracao.conteudo.colunas[idx]
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-pencil"
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (idx > 0),
          expression: "idx > 0"
        }],
        staticClass: "botao_acao_elemento elemento_mover",
        on: {
          "click": function($event) {
            return _vm.moveElemento(idx, -1, controle.configuracao.conteudo.colunas)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-arrow-up"
      })]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (idx < controle.configuracao.conteudo.colunas.length - 1),
          expression: "idx < controle.configuracao.conteudo.colunas.length - 1"
        }],
        staticClass: "botao_acao_elemento elemento_mover",
        on: {
          "click": function($event) {
            return _vm.moveElemento(idx, 1, controle.configuracao.conteudo.colunas)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-arrow-down"
      })]), _vm._v(" "), (controle.configuracao.conteudo.colunas.length > 1) ? _c('span', {
        staticClass: "botao_acao_conteudo elemento_excluir",
        on: {
          "click": function($event) {
            return controle.configuracao.conteudo.colunas.splice(idx, 1)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })]) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "adicionaComponente",
      attrs: {
        "colspan": "2"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.colunaParaAdicionarSubFormulario),
        expression: "colunaParaAdicionarSubFormulario"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.colunaParaAdicionarSubFormulario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          return _vm.adicionaColunaSubFormulario(idx)
        }]
      }
    }, _vm._l((controle.configuracao.conteudo.formulario), function(item) {
      return (_vm._.includes(['CONTROLE', 'PERSONALIZADO'], item.grupo)) ? _c('option', {
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                                                    (" + _vm._s(item.id) + ") " + _vm._s(_vm.removerTagHtmlString(item.titulo)) + "\n                                                  ")]) : _vm._e()
    }), 0)])])] : _vm._e()], 2), _vm._v(" "), (!_vm._.isEmpty(_vm.editandoColunaSubFormulario)) ? [_c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editandoColunaSubFormulario.label),
        expression: "editandoColunaSubFormulario.label"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.editandoColunaSubFormulario.label)
      },
      on: {
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
          _vm.editandoColunaSubFormulario = {}
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.editandoColunaSubFormulario, "label", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "botao_acao_elemento elemento_fechar",
      on: {
        "click": function($event) {
          _vm.editandoColunaSubFormulario = {}
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })])])]), _vm._v(" "), _c('tr', [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v("Muda o nome da coluna acima. Isto só altera a coluna, não o titulo da questão no formulário.")])])] : _vm._e()], 2)])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO', 'SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO', 'CLASSIFICACAO', 'NPS', 'LIKERT'], controle.elemento) || (controle.elemento === 'NUMERO' && _vm._.includes(['INTEIRO', 'DECIMAL', 'MOEDA'], controle.configuracao.formato))) ? _c('div', {
      attrs: {
        "id": "regras_formulario"
      }
    }, [_c('div', {
      class: 'col-md-12' + (_vm._.sumBy(controle.configuracao.regras, function(r) {
        return _vm._.isNull(r.valor) || r.valor === '' || r.id.length === 0 ? 1 : 0
      }) > 0 ? ' regras_erro' : (controle.configuracao.regras.length > 0 ? ' regras_ok' : ''))
    }, [_c('div', {
      staticClass: "btn-primary cabecalho_regras"
    }, [_c('span', {
      staticClass: "text-bold"
    }, [(controle.configuracao.regras.length === 0) ? _c('span', [_vm._v("Nenhuma Regra")]) : _c('span', [_vm._v("\n                                        Há " + _vm._s(controle.configuracao.regras.length) + " regra(s)\n\n                                        "), (_vm._.sumBy(controle.configuracao.regras, function(r) {
      return _vm._.isNull(r.valor) || r.valor === '' ? 1 : 0
    }) > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('div', {
      staticClass: "espacamento_botoes"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" " + _vm._s(_vm._.sumBy(controle.configuracao.regras, function(r) {
      return _vm._.isNull(r.valor) || r.valor === '' ? 1 : 0
    })) + " sem valor informado\n                                        ")]) : _vm._e(), _vm._v(" "), (_vm._.sumBy(controle.configuracao.regras, function(r) {
      return r.id.length === 0 ? 1 : 0
    }) > 0) ? _c('span', {
      staticClass: "text-danger"
    }, [_c('div', {
      staticClass: "espacamento_botoes"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-exclamation-circle"
    }), _vm._v(" " + _vm._s(_vm._.sumBy(controle.configuracao.regras, function(r) {
      return r.id.length === 0 ? 1 : 0
    })) + " sem destino da ação selecionado\n                                        ")]) : _vm._e()])]), _vm._v(" "), _c('span', {
      staticClass: "botoes_acao_conteudo",
      staticStyle: {
        "display": "block"
      }
    }, [_c('span', {
      staticClass: "botao_acao_conteudo elemento_duplicar",
      on: {
        "click": function($event) {
          controle.configuracao.regras.push({
            condicao: (_vm._.includes(['NUMERO'], controle.elemento) ? 'IGUAL' : (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento) ? 'CONTEM' : 'ITEM_SELECIONADO')),
            valor: null,
            acao: 'MOSTRAR',
            id: []
          })
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })]), _vm._v(" "), (controle.configuracao.regras.length > 0) ? _c('span', {
      staticClass: "botao_acao_conteudo elemento_excluir",
      on: {
        "click": function($event) {
          controle.configuracao.regras = []
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])]), _vm._v(" "), (controle.configuracao.regras.length > 0) ? _c('table', {
      staticClass: "table lista_regras"
    }, _vm._l((controle.configuracao.regras), function(regra, idxRegra) {
      return _c('tr', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: '20',
            size: 'large',
            arrow: true,
            followCursor: true
          }),
          expression: "{inertia:true, arrow:true, animation:'perspective', distance:'20', size:'large', arrow:true, followCursor:true}"
        }],
        attrs: {
          "title": _vm._.isNull(regra.valor) || regra.valor === '' || regra.id.length === 0 ?
            '<h5>Regra inválida. Complete ou exclua ela</h5>' :

            '<h5>Se a resposta da questão ' +
            (_vm._.includes(['CONTEM', 'NAO_CONTEM'], regra.condicao) ? '' : (_vm._.includes(['VAZIO', 'NAO_VAZIO', 'ENTRE'], regra.condicao) ? 'está' : (_vm._.includes(['ITEM_SELECIONADO', 'ITEM_NAO_SELECIONADO'], regra.condicao) ? 'tem o' : 'é'))) + ' ' +
            '<span class=\'realce\'>' + (_vm._.toLower(_vm._.replace(regra.condicao, '_', ' '))) + '</span> ' +
            (_vm._.includes(['CONTEM', 'NAO_CONTEM'], regra.condicao) ? 'o valor' : (_vm._.includes(['VAZIO', 'NAO_VAZIO', 'ENTRE'], regra.condicao) ? '' : (_vm._.includes(['ITEM_SELECIONADO', 'ITEM_NAO_SELECIONADO'], regra.condicao) ? 'com a opção' : (regra.condicao === 'IGUAL' ? 'a' : (regra.condicao === 'DIFERENTE' ? 'de' : 'que'))))) + ' ' +
            '<span class=\'realce\'>' + ((_vm._.includes(['VAZIO', 'NAO_VAZIO'], regra.condicao) ? '' : regra.valor) + (regra.condicao === 'ENTRE' ? ' e ' + regra.valor2 : '')) + '</span>' + (controle.elemento === 'LIKERT' ? ' para a pergunta <span class=\'realce\'>' + regra.valor2 + '</span>' : '') + ', ' +
            'então deve <span class=\'realce\'>' + _vm._.toLower(regra.acao) + '</span> ' + (regra.id.length > 1 ? 'estes' : 'este') + '<span class=\'realce\'> ' + regra.id.length + ' </span>' + (regra.id.length > 1 ? 'elementos' : 'elemento') + '</h5>'
        }
      }, [_c('td', {
        staticClass: "w20"
      }, [(_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento)) ? _c('span', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.condicao),
          expression: "regra.condicao"
        }],
        staticClass: "form-control b0",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(regra, "condicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "CONTEM"
        }
      }, [_vm._v("Contém")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "NAO_CONTEM"
        }
      }, [_vm._v("Não contém")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "VAZIO"
        }
      }, [_vm._v("Vazio")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "NAO_VAZIO"
        }
      }, [_vm._v("Não vazio")])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['CLASSIFICACAO', 'NPS', 'NUMERO'], controle.elemento)) ? _c('span', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.condicao),
          expression: "regra.condicao"
        }],
        staticClass: "form-control b0",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(regra, "condicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "VAZIO"
        }
      }, [_vm._v("Está vazio")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "NAO_VAZIO"
        }
      }, [_vm._v("Não está vazio")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "ENTRE"
        }
      }, [_vm._v("Entre")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "IGUAL"
        }
      }, [_vm._v("Igual")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "DIFERENTE"
        }
      }, [_vm._v("Diferente")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "MAIOR"
        }
      }, [_vm._v("Maior que")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "MAIOR_IGUAL"
        }
      }, [_vm._v("Maior ou igual que")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "MENOR"
        }
      }, [_vm._v("Menor que")]), _vm._v(" "), _c('option', {
        attrs: {
          "value": "MENOR_IGUAL"
        }
      }, [_vm._v("Menor ou igual que")])])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO', 'LIKERT'], controle.elemento)) ? _c('span', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.condicao),
          expression: "regra.condicao"
        }],
        staticClass: "form-control b0",
        attrs: {
          "disabled": true
        },
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(regra, "condicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, [_c('option', {
        attrs: {
          "value": "ITEM_SELECIONADO"
        }
      }, [_vm._v("Se selecionado")]), _vm._v(" "), (false) ? _c('option', {
        attrs: {
          "value": "ITEM_NAO_SELECIONADO"
        }
      }, [_vm._v("Se Não selecionado")]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "w20",
        class: (_vm._.isNull(regra.valor) || regra.valor === '') || (_vm._.has(regra, 'valor2') && (_vm._.isNull(regra.valor2) || regra.valor2 === '')) ? 'has-error' : ''
      }, [(!_vm._.includes(['VAZIO', 'NAO_VAZIO'], regra.condicao)) ? _c('span', [(_vm._.includes(['CLASSIFICACAO', 'NPS', 'NUMERO'], controle.elemento)) ? _c('span', {
        staticClass: "regraEntre"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.valor),
          expression: "regra.valor"
        }],
        staticClass: "form-control b0",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (regra.valor)
        },
        on: {
          "keyup": function($event) {
            regra.valor = _vm._.toSafeInteger(('' + regra.valor).replace(/\D+/g, ''))
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(regra, "valor", $event.target.value)
          }
        }
      }), _vm._v(" "), (regra.condicao === 'ENTRE') ? _c('span', [_vm._v(" e ")]) : _vm._e(), _vm._v(" "), (regra.condicao === 'ENTRE') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.valor2),
          expression: "regra.valor2"
        }],
        staticClass: "form-control b0",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (regra.valor2)
        },
        on: {
          "keyup": function($event) {
            regra.valor2 = _vm._.toSafeInteger(('' + regra.valor2).replace(/\D+/g, ''))
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(regra, "valor2", $event.target.value)
          }
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.includes(['TEXTO_SIMPLES', 'TEXTO_LONGO'], controle.elemento)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.valor),
          expression: "regra.valor"
        }],
        staticClass: "form-control b0",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (regra.valor)
        },
        on: {
          "keyup": function($event) {
            regra.valor = _vm._.toLower(regra.valor)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(regra, "valor", $event.target.value)
          }
        }
      })]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SELECAO_SIMPLES', 'SELECAO_MULTIPLA', 'BOOLEANO'], controle.elemento)) ? _c('span', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.valor),
          expression: "regra.valor"
        }],
        staticClass: "form-control b0",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(regra, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((controle.configuracao.conteudo.linhas), function(item) {
        return _c('option', [_vm._v(_vm._s(item.descricao))])
      }), 0)]) : _vm._e(), _vm._v(" "), (_vm._.includes(['LIKERT'], controle.elemento)) ? _c('span', [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.valor2),
          expression: "regra.valor2"
        }],
        staticClass: "form-control b0",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(regra, "valor2", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((controle.configuracao.conteudo.linhas), function(item) {
        return _c('option', [_vm._v(_vm._s(item.descricao))])
      }), 0), _vm._v(" "), _c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (regra.valor),
          expression: "regra.valor"
        }],
        staticClass: "form-control b0",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.$set(regra, "valor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
          }
        }
      }, _vm._l((controle.configuracao.conteudo.colunas), function(item) {
        return _c('option', [_vm._v(_vm._s(item.descricao))])
      }), 0)]) : _vm._e()]) : _c('span', [_vm._v(" ")])]), _vm._v(" "), _c('td', [_c('i', {
        class: (regra.acao === 'MOSTRAR' ? 'fa fa-2x fa-eye' : 'fa fa-2x fa-eye-slash'),
        staticStyle: {
          "color": "var(--cor-destaque)",
          "cursor": "pointer",
          "text-align": "center"
        },
        attrs: {
          "aria-hidden": "true"
        },
        on: {
          "click": function($event) {
            regra.acao = regra.acao === 'MOSTRAR' ? 'OCULTAR' : 'MOSTRAR'
          }
        }
      })]), _vm._v(" "), _c('td', {
        class: regra.id.length === 0 ? 'regra_error' : ''
      }, [_c('multiselect', {
        attrs: {
          "options": _vm._.filter(_vm.editandoFormulario, function(o) {
            return o.id !== controle.id
          }),
          "multiple": true,
          "close-on-select": true,
          "placeholder": 'Selecione ao menos um elemento',
          "track-by": "id",
          "label": "id",
          "selectedLabel": "",
          "selectLabel": "",
          "deselectLabel": "",
          "name": "id_elementos",
          "data-vv-as": "id_elementos"
        },
        scopedSlots: _vm._u([{
          key: "option",
          fn: function(props) {
            return [_c('span', {
              staticClass: "text-gray"
            }, [_vm._v(_vm._s(props.option.id))]), _vm._v(" "), _c('span', {
              staticClass: "ocultarLinhaAdicionalQuill",
              domProps: {
                "innerHTML": _vm._s(props.option.titulo)
              }
            })]
          }
        }], null, true),
        model: {
          value: (regra.id),
          callback: function($$v) {
            _vm.$set(regra, "id", $$v)
          },
          expression: "regra.id"
        }
      })], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "botoes_acao_conteudo",
        staticStyle: {
          "display": "block"
        }
      }, [_c('span', {
        staticClass: "botao_acao_conteudo elemento_duplicar",
        on: {
          "click": function($event) {
            controle.configuracao.regras.splice(idxRegra, 0, _vm._.clone(controle.configuracao.regras[idxRegra]))
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-files-o"
      })]), _vm._v(" "), _c('span', {
        staticClass: "botao_acao_conteudo elemento_excluir",
        on: {
          "click": function($event) {
            return controle.configuracao.regras.splice(idxRegra, 1)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash"
      })])])])])
    }), 0) : _vm._e()])]) : _vm._e()]) : _vm._e()]) : _vm._e()])
  }), 0)], 1)]), _vm._v(" "), (_vm.mostrarComponentes) ? _c('div', {
    staticClass: "col-md-3",
    style: ('overflow-y: auto; height: ' + (_vm.alturaContentWrapper - (_vm.mostrarTitulo ? 372 : 94)) + 'px;'),
    attrs: {
      "id": "componentes_formulario"
    }
  }, [(_vm.loading.componentes) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando banco de questões ...")]) : _vm._e(), _vm._v(" "), (!_vm.loading.componentes) ? _c('span', [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa.termo),
      expression: "pesquisa.termo"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, delay: [500, 0]}"
    }],
    ref: "pesquisaControle",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa...",
      "title": '<h5>Digite algo</h5>'
    },
    domProps: {
      "value": (_vm.pesquisa.termo)
    },
    on: {
      "keyup": _vm.filtrar,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.pesquisa.termo = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pesquisa, "termo", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.pesquisa.termo.length > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "input-group-btn",
    attrs: {
      "title": '<h5>Limpar essa pesquisa [ESC]</h5>'
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "white",
      "border-color": "#d2d6de",
      "border-width": "1px 0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pesquisa.termo = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    class: 'btn btn-default btn-flat' + (_vm.pesquisa.personalizado ? ' bg-gray' : ''),
    attrs: {
      "type": "button",
      "title": '<h5>Questões fechadas/personalizadas da FBB</h5>'
    },
    on: {
      "click": function($event) {
        _vm.pesquisa.personalizado = !_vm.pesquisa.personalizado
      }
    }
  }, [_c('i', {
    class: _vm.pesquisa.personalizado ? 'fa fa-file-text fa-inverse' : 'fa fa-file-text'
  })])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    class: 'btn btn-default btn-flat' + (_vm.pesquisa.formulario ? ' bg-gray' : ''),
    attrs: {
      "type": "button",
      "title": '<h5>Formulários genéricos ou participantes</h5>'
    },
    on: {
      "click": function($event) {
        _vm.pesquisa.formulario = !_vm.pesquisa.formulario
      }
    }
  }, [_c('i', {
    class: _vm.pesquisa.formulario ? 'fa fa-list-alt fa-inverse' : 'fa fa-list-alt'
  })])])])])])]), _vm._v(" "), _vm._l((_vm._.groupBy(_vm._.filter(_vm._.orderBy(_vm.controles, ['informacao'], ['asc']), {
    'mostrar': true
  }), 'grupo')), function(controlesLista, grupo) {
    return [_c('div', {
      staticClass: "text-muted text-bold"
    }, [_vm._v(_vm._s(_vm.gruposControles[grupo])), _c('span', {
      staticClass: "contador"
    }, [_vm._v(_vm._s(controlesLista.length))])]), _vm._v(" "), _c('draggable', {
      staticClass: "list-group",
      attrs: {
        "tag": "ul",
        "list": controlesLista,
        "group": {
          name: 'edicao',
          pull: 'clone',
          put: false
        },
        "clone": _vm.clonarControle,
        "move": _vm.mover
      }
    }, _vm._l((controlesLista), function(controle) {
      return _c('li', {
        class: 'list-group-item ' + (_vm._.find(_vm.editandoFormulario, ['id', controle.bi]) ? 'bi_repetido' : ''),
        on: {
          "click": function($event) {
            return _vm.adicionaControle(controle)
          }
        }
      }, [_c('div', {
        staticClass: "truncar"
      }, [(controle.bi) ? _c('i', {
        staticClass: "fa fa-pie-chart"
      }) : _vm._e(), _vm._v(" "), _c('i', {
        class: 'text-gray fa ' + (controle.grupo === 'FORMULARIO' ? _vm.icones[controle.configuracao.conteudo.tipo] : (controle.elemento === 'NUMERO' ? _vm.icones[controle.configuracao.formato] : _vm.icones[controle.elemento]))
      }), _vm._v("\n                            " + _vm._s(controle.informacao) + "\n                          ")]), _vm._v(" "), (!_vm._.isEmpty(controle.descricao)) ? _c('i', {
        directives: [{
          name: "tippy",
          rawName: "v-tippy",
          value: ({
            inertia: true,
            arrow: true,
            animation: 'perspective',
            distance: 15,
            size: 'large',
            arrow: true
          }),
          expression: "{inertia:true, arrow:true, animation:'perspective', distance: 15, size:'large', arrow:true}"
        }],
        staticClass: "fa fa-question-circle text-gray",
        staticStyle: {
          "margin-left": "5px"
        },
        attrs: {
          "title": '<h5>' + (_vm._.find(_vm.editandoFormulario, ['id', controle.bi]) ? '<span class=\'realce\'>Elementos de BI com este só podem ter um no formulário</span><br/>' : '') + controle.descricao + '</h5>'
        }
      }) : _vm._e()])
    }), 0)]
  }), _vm._v(" "), (!_vm._.find(_vm.controles, {
    'mostrar': true
  })) ? _c('p', {
    staticClass: "text-muted font-italic"
  }, [_vm._v("Não encontrei!")]) : _vm._e()], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-55285b83!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/avaliacao/EditaFormulario.vue
// module id = 1960
// module chunks = 1